import { Image, Box, Text } from 'rebass';
import { get, isEmpty } from 'lodash';
import Lazyload from 'react-lazyload';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useContext } from 'react';
import dynamic from 'next/dynamic';
import useEntity from './hooks/useEntity';
import { StoryPageContext } from './StoryPage';

const AudioMedium = dynamic(import('./audio-medium/AudioMedium'), { ssr: false });

const ImageMedium = ({ height, medium, captionTextId, captionAudioId, isCarousel }) => {
  const captionText = useEntity({
    type: 'texts',
    id: captionTextId || '',
  });
  const captionAudio = useEntity({
    type: 'audios',
    id: captionAudioId || '',
  });
  const [src, setSrc] = useState(get(medium, '["image-versions"][0].url', ''));
  const { setLightboxMedia } = useContext(StoryPageContext);

  useEffect(() => {
    setSrc(get(medium, '["image-versions"][0].url', ''));
  }, []);

  return (
    <Lazyload offset={200} once height={height}>
      <Box css="position: relative;" onClick={() => setLightboxMedia(medium.id)}>
        <Image
          src={src}
          style={{
            display: 'block',
            maxHeight: isCarousel ? '400px' : 'auto',
            margin: 'auto',
            width: isCarousel ? 'auto' : '100%',
          }}
        />
        {!isEmpty(captionAudio) && (
          <Box bg="photoGradientEnd" css="position: absolute; bottom: 0; width: 100%;">
            <AudioMedium medium={captionAudio} />
          </Box>
        )}
        {!isEmpty(captionText) && (
          <Box p={3} bg="photoGradientEnd" css="position: absolute; bottom: 0; width: 100%;">
            <Text
              color="white"
              css="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;"
            >
              {captionText.text}
            </Text>
          </Box>
        )}
      </Box>
    </Lazyload>
  );
};

ImageMedium.defaultProps = {
  captionAudioId: '',
  captionTextId: '',
};

ImageMedium.propTypes = {
  height: PropTypes.number.isRequired,
  medium: PropTypes.shape({}).isRequired,
  captionAudioId: PropTypes.string,
  captionTextId: PropTypes.string,
};

export default ImageMedium;
